import { hasUnsavedFormChanges } from "../../../common/formStateDirty";

type SettingsQueryRefreshInput<Value> = {
  activeChamberId: string;
  baseline: Value | null;
  current: Value | null;
  hasExternalUnsavedChanges?: boolean;
  incomingChamberId: string;
};

/**
 * A new chamber must never keep the prior chamber's form. For the same
 * chamber, query refreshes can replace the form only while the saved form is
 * clean. A caller can keep a skipped refresh pending and apply it after reset.
 */
export const shouldApplySettingsQueryRefresh = <Value>({
  activeChamberId,
  baseline,
  current,
  hasExternalUnsavedChanges = false,
  incomingChamberId,
}: SettingsQueryRefreshInput<Value>): boolean => {
  if (
    !activeChamberId ||
    activeChamberId !== incomingChamberId ||
    !baseline ||
    !current
  ) {
    return true;
  }

  if (hasExternalUnsavedChanges) {
    return false;
  }

  return !hasUnsavedFormChanges({ baseline, current });
};
